import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "selfAnalysis"
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("自主分析")]), _c('div', {
    staticClass: "sa_toolbar"
  }, [_c('label', {
    staticClass: "sa_label"
  }, [_vm._v("案場")]), _c('multiselect', {
    staticClass: "sa_site",
    attrs: {
      "options": _vm.siteOptions,
      "disabled": !_vm.siteOptions.length,
      "group-values": "options",
      "group-label": "label",
      "track-by": "value",
      "label": "text",
      "placeholder": "輸入案場代號或名稱",
      "allow-empty": false,
      "show-labels": false,
      "max-height": 500
    },
    model: {
      value: _vm.selectedSite,
      callback: function callback($$v) {
        _vm.selectedSite = $$v;
      },
      expression: "selectedSite"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("查無案場")])]), _vm.withData.length ? _c('span', {
    staticClass: "sa_stamp"
  }, [_vm._v(" 已建主檔：" + _vm._s(_vm.withData.map(function (s) {
    return s.code;
  }).join('、')) + " ")]) : _vm.siteOptions.length ? _c('span', {
    staticClass: "sa_stamp"
  }, [_vm._v("目前還沒有任何案場建過主檔")]) : _vm._e()], 1), _vm.site && _vm.site.plants && _vm.site.plants.length ? _c('div', {
    staticClass: "sa_toolbar sa_plants"
  }, [_vm.site.standalone ? [_c('span', {
    staticClass: "sa_stamp"
  }, [_vm._v("此為其他監控來源（" + _vm._s(_vm.site.plants[0].provider) + "）的電廠，若與既有案場是同一座：")]), _c('multiselect', {
    staticClass: "sa_site",
    attrs: {
      "options": _vm.mergeOptions,
      "track-by": "value",
      "label": "text",
      "placeholder": "輸入要併入的案場",
      "show-labels": false,
      "max-height": 400
    },
    model: {
      value: _vm.selectedMergeTarget,
      callback: function callback($$v) {
        _vm.selectedMergeTarget = $$v;
      },
      expression: "selectedMergeTarget"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("查無案場")])]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": !_vm.mergeTarget || _vm.busy
    },
    on: {
      "click": _vm.link
    }
  }, [_vm._v("併入")])] : [_c('span', {
    staticClass: "sa_stamp"
  }, [_vm._v("對應監控來源：")]), _vm._l(_vm.site.plants, function (p) {
    return _c('span', {
      key: p.provider + p.plant_no,
      staticClass: "sa_plant"
    }, [_vm._v(" " + _vm._s(p.name || p.plant_no) + "（" + _vm._s(p.provider) + " " + _vm._s(p.plant_no) + "） "), p.linked ? _c('b-button', {
      staticClass: "p-0 ml-1",
      attrs: {
        "size": "sm",
        "variant": "link",
        "disabled": _vm.busy
      },
      on: {
        "click": function click($event) {
          return _vm.unlink(p);
        }
      }
    }, [_vm._v("拆開")]) : _vm._e()], 1);
  })]], 2) : _vm._e(), _vm.error ? _c('b-alert', {
    staticClass: "mx-2 py-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle mr-1"
  }), _vm._v(_vm._s(_vm.error) + " ")]) : _vm._e(), !_vm.schema && !_vm.error ? _c('b-spinner', {
    staticClass: "mx-3 my-4",
    attrs: {
      "variant": "secondary"
    }
  }) : _vm._e(), _vm.schema ? _c('b-tabs', {
    staticClass: "mx-2",
    attrs: {
      "nav-class": "sa_segment",
      "lazy": ""
    },
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-sitemap"
        }), _vm._v("拓撲階層")];
      },
      proxy: true
    }], null, false, 2340396897)
  }, [_c('TopologyNodesPanel', {
    attrs: {
      "def": _vm.schema.inverter_topology_nodes,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-bolt"
        }), _vm._v("節點標準電壓")];
      },
      proxy: true
    }], null, false, 543784497)
  }, [_c('VoltageConfigsPanel', {
    attrs: {
      "def": _vm.schema.node_voltage_configs,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-server"
        }), _vm._v("INV主檔")];
      },
      proxy: true
    }], null, false, 1991822822)
  }, [_c('InverterMasterPanel', {
    attrs: {
      "def": _vm.schema.inverter_master,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-project-diagram"
        }), _vm._v("MPPT串列對應")];
      },
      proxy: true
    }], null, false, 4212372680)
  }, [_c('MpptStringMapPanel', {
    attrs: {
      "def": _vm.schema.mppt_string_map,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-solar-panel"
        }), _vm._v("串列設計")];
      },
      proxy: true
    }], null, false, 1698391141)
  }, [_c('StringDesignPanel', {
    attrs: {
      "def": _vm.schema.string_design,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-list-ol"
        }), _vm._v("INV狀態碼對照")];
      },
      proxy: true
    }], null, false, 168824541)
  }, [_c('StatusCodesPanel', {
    attrs: {
      "def": _vm.schema.site_inverter_status_codes,
      "site-code": _vm.siteCode
    },
    on: {
      "changed": _vm.loadSites
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };